export function getMapping(index) {

    var routes = {
        "MoneyModule" : "/"
    };
    return routes["MoneyModule"];
}